import React from "react";
import { MessageSquare } from "lucide-react";
import { SMS_HREF } from "./constants";
import { track } from "@/lib/analytics";

export function Header() {
  return (
    <header
      className="sticky top-0 z-50 bg-[#FFFFFF]/85 backdrop-blur-xl border-b border-[#E5E5E5]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 sm:h-24 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center" data-testid="brand-link">
          <img
            src="/logo-v2.png"
            alt="Glenwood Gutter Guy — One guy. One ladder. Done right."
            className="h-16 sm:h-20 w-auto object-contain"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#4A4A46]">
          <a href="#services" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-services">
            Services
          </a>
          <a href="#area" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-area">
            Service Area
          </a>
          <a href="#contact" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-contact">
            Contact
          </a>
          <a href="/blog" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-blog">
            Blog
          </a>
          <a href="/plans" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-plans">
            Plans
          </a>
          <a href="/pay" className="hover:text-[#5FBE1F] transition-colors" data-testid="nav-pay">
            Pay Online
          </a>
        </nav>
        <a
          href={SMS_HREF}
          onClick={() => track("text_gutters_click", { location: "header" })}
          className="hidden sm:inline-flex items-center gap-2 bg-[#5FBE1F] text-white px-4 py-2 rounded-sm text-sm font-bold hover:bg-[#4A9818] transition-all"
          data-testid="header-text-cta"
        >
          <MessageSquare className="w-4 h-4" />
          Text "Gutters"
        </a>
      </div>
    </header>
  );
}
